// base styles
import borders from "assets/mavric-theme/base/borders";
import colors from "assets/mavric-theme/base/colors";

//helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import linearGradient from "assets/mavric-theme/functions/linearGradient";

const { borderWidth, borderColor } = borders;
const { transparent, secondary } = colors;

const radio = {
  styleOverrides: {
    root: {
      "& .MuiSvgIcon-root": {
        width: pxToRem(16),
        height: pxToRem(16),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${borderColor}`,
        borderRadius: "50%",
      },

      "&:after": {
        transition: "opacity 250ms ease-in-out",
        content: `""`,
        position: "absolute",
        width: pxToRem(10),
        height: pxToRem(10),
        borderRadius: "50%",
        backgroundImage: linearGradient(secondary.main, secondary.main),
        opacity: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        border: `${borderWidth[2]} solid ${secondary.main} !important`,
      },
    },

    colorPrimary: {
      color: borderColor,

      "&.Mui-checked": {
        color: secondary.main,

        "& .MuiSvgIcon-root": {
          borderColor: secondary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },

    colorSecondary: {
      color: borderColor,

      "&.Mui-checked": {
        color: secondary.main,

        "& .MuiSvgIcon-root": {
          borderColor: secondary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },
  },
};

export default radio;
